<template>
  <div class="rescues">
    <span id="c-add-up">
      <RescuesUpdate
        v-if="showUpdate"
        @showUpdate="close"
        @showMore="showMore"
        :page="page"
        :titleCard="titleCard"
        :updateData="updateData"
      />
    </span>
    <va-card :title="$t('rescues.cards.title')">
      <va-data-table
        :fields="fields"
        :data="rescues"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem dados cadastrados"
        api-mode
      >
        <template slot="actions" slot-scope="props">
          <va-popover :message="`${$t('rescues.tooltips.update')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-pencil"
              href="#c-add-up"
              @click="update(props.rowData)"
            />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import RescuesUpdate from './RescuesUpdate.vue'

const perPage = 10
export default {
  name: 'Resgates',
  components: {
    RescuesUpdate,
  },
  methods: {
    close (v) {
      this.showUpdate = v
      this.updateData = null
    },
    update (data) {
      this.titleCard = 'update'
      this.updateData = data
      this.showUpdate = true
    },
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.order.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
  },
  data () {
    return {
      rescues: [],
      name: '',
      page: 1,
      perPage: perPage,
      pages: null,
      loading: false,
      showUpdate: false,
      titleCard: '',
      updateData: null,
    }
  },
  apollo: {
    order: {
      query: gql`
        query MyQuery($perPage: Int, $page: Int) {
          order(order_by: {id: desc}, limit: $perPage, offset: $page) {
            id
            order_status_id
            order_status {
              name
              id
            }
            product {
              name
            }
            client {
              id
              fullName
            }
            tracking_code
          }
        }
      `,
      variables () {
        return {
          perPage,
          page: 0,
        }
      },
      result ({ data, loading }) {
        if (!loading) {
          if (data.order.length > 0) {
            this.rescues = data.order
          }
        }
      },
    },
    pages: {
      query: gql`
      query MyQuery {
        pages: order_aggregate {
          aggregate {
            count
          }
        }
      }
      `,
    },
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    fields () {
      return [
        {
          name: 'client.fullName',
          title: this.$t('rescues.headings.name'),
        },
        {
          name: 'product.name',
          title: this.$t('rescues.headings.product'),
          dataClass: 'text-center',
          titleClass: 'text-center',
        },
        {
          name: 'tracking_code',
          title: this.$t('rescues.headings.trackingCode'),
          callback (value) {
            return value ?? ''
          },
          dataClass: 'text-center',
          titleClass: 'text-center',
        },
        {
          name: 'order_status.name',
          title: this.$t('rescues.headings.status'),
          dataClass: 'text-center',
          titleClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: this.$t('tables.actions'),
          dataClass: 'text-center',
          titleClass: 'text-center',
        },
      ]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('order')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.order.refetch()
    }
  },
}
</script>

<style lang="scss" scoped>
.img-logo img {
  width: 5rem;
  border-radius: 50%;
}
</style>
